// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"dcef733d","16":"ef5c107a","43":"e9e32244","245":"e48ac192","391":"ab5bf7fe","533":"d6de05ad","633":"9800fe3c","736":"71f194ac","812":"4924aa69","950":"1d49616a"}[chunkId] + ".chunk.js";
};